import { urlVars, vars } from '@repo/config';
import { getClientConfig } from '../httpClient/configuration/client-instance';

function resolveIdentityBaseUrl(): string {
  const configuredUrl = vars.url.identityUrl;
  const navigatorProduct =
    typeof navigator !== 'undefined'
      ? (navigator as Navigator & { product?: string }).product
      : undefined;
  const isReactNativeRuntime = navigatorProduct === 'ReactNative';
  const isLocalhostTarget =
    configuredUrl.startsWith('http://localhost') || configuredUrl.startsWith('http://127.0.0.1');
  if (isReactNativeRuntime && isLocalhostTarget) {
    return urlVars.prod.identityUrl;
  }
  return configuredUrl;
}

export async function fetchTelegramIdentityRequest(
  path: string,
  init: RequestInit,
): Promise<Response> {
  const config = getClientConfig();
  const providerHeaders = (await config.headerProvider?.()) ?? {};
  const mergedHeaders = {
    ...config.defaultHeaders,
    ...providerHeaders,
    ...(init.headers as Record<string, string> | undefined),
  };
  return fetch(new URL(path, resolveIdentityBaseUrl()).toString(), {
    ...init,
    headers: mergedHeaders,
    credentials: 'include',
  } as RequestInit);
}
